import { useReadContract } from 'wagmi';
import { scroogeAbi, SCROOGE_ADDRESS, IS_DEPLOYED } from '../../lib/contract';

// Планы хардкодятся в конструкторе контракта и меняются только через setPlanActive —
// кешируем навсегда. При reconnect/invalidate перечитываются.
export function useAllPlans() {
  return useReadContract({
    address: SCROOGE_ADDRESS,
    abi: scroogeAbi,
    functionName: 'getAllPlans',
    query: {
      enabled: IS_DEPLOYED,
      staleTime: Infinity,
      gcTime: Infinity,
    },
  });
}

// Hardcoded fallback — используется пока контракт не задеплоен, чтобы UI кабинета работал
// (с демо-данными планов). Числа совпадают с конструктором ScroogeFinance.sol.
// Последняя запись — DEMO-only тестовая стратегия (10 мин, 1%/10min = 14400 bps/day).
// На реальном контракте её нет.
export const FALLBACK_PLANS = [
  { durationDays: 1, dailyBps: 50, active: true },
  { durationDays: 5, dailyBps: 70, active: true },
  { durationDays: 10, dailyBps: 80, active: true },
  { durationDays: 15, dailyBps: 90, active: true },
  { durationDays: 20, dailyBps: 100, active: true },
  { durationDays: 25, dailyBps: 110, active: true },
  { durationDays: 30, dailyBps: 120, active: true },
  // DEMO ONLY — test strategy
  { durationDays: 0, durationSeconds: 600, dailyBps: 14400, active: true, isTest: true },
];
